module.exports = __webpack_public_path__ + "img/img-5.12e6feca.png";